const moneyFormat = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return /(?=.*?\d)^(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(value);
};

export default moneyFormat;
